import { Button, TYPE_LINK } from '@eventbrite/eds-button';
import { GenericLazyString, gettext } from '@eventbrite/i18n';
import React from 'react';
import { Link } from 'react-router-dom';

interface SeeMoreButtonprops {
    /**
     * Title of parent bucket
     */
    title: string | GenericLazyString;
    /**
     * The url the user should be directed to
     */
    linkUrl: string;
    /**
     * The text the button should display
     */
    seeMoreText?: string;
    /**
     * Tracking callback for button clicks
     */
    trackClick: Function;
    /**
     * String representing user action to send to GA
     */
    gaAction: string;
    /**
     * String representing component display size; defaults to 'respnsive'
     */
    size: string;
    /**
     * If the component should render a link
     */
    enableClientSideLinking?: boolean;
}

export class SeeMoreButton extends React.PureComponent<SeeMoreButtonprops> {
    static defaultProps = {
        size: 'responsive',
    };

    render() {
        const {
            title,
            linkUrl,
            seeMoreText,
            trackClick,
            gaAction,
            size,
            enableClientSideLinking,
        } = this.props;
        const ariaLabel = seeMoreText
            ? seeMoreText
            : gettext('See more %(title)s', { title });
        const buttonLabel = seeMoreText ? seeMoreText : gettext('See more');

        let component = null;

        if (linkUrl) {
            component = enableClientSideLinking ? (
                <Link
                    aria-label={`${ariaLabel.toString()}`}
                    to={linkUrl}
                    onClick={trackClick.bind(null, { url: linkUrl }, gaAction)}
                >
                    {buttonLabel}
                </Link>
            ) : (
                <Button
                    type={TYPE_LINK}
                    href={linkUrl}
                    onClick={trackClick.bind(null, { url: linkUrl }, gaAction)}
                    aria-label={ariaLabel}
                    size={size}
                >
                    {buttonLabel}
                </Button>
            );
        }

        return component;
    }
}
